(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-section-1"] && !window.DesignMode) return;
  try {
    
// Javascript
  
// end of Javascript  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_page"] && !window.DesignMode) return;
  try {
    
// Javascript

// end of Javascript

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tensile-chart"] && !window.DesignMode) return;
  try {
    
$('.tab-menu li a').on('click', function(){

    var target = $(this).attr('data-rel');

    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});

//const ctx = document.getElementById('myChart');

//   new Chart(ctx, {
//     type: 'line',
//     data: {
//       labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
//       datasets: [{
//         label: '# of Votes',
//         data: [0,10,20,30,38,40,38,45,50,50,45,39,34,29],
//         borderWidth: 3,
//         borderColor: '#EC0000', 
//         fill: true,
//         backgroundColor: '#ff000036',
//         lineTension: 0.5,
//       },
//       {
//         label: '# of ALTERNATIVES',
//         data: [0,7,17,27,35,37,35,42,47,47,42,36,31,26],
//         borderWidth: 3,
//         borderColor: '#8630FF', 
//         fill: true,
//         backgroundColor: '#d898d699',
//         lineTension: 0.5,
//       }]
//     },
//     options: {
//     //   scales: {
//     //     y: {
//     //       beginAtZero: true
//     //     }
//     //   }
//     }
// });

// const ctx2 = document.getElementById('myChart2');

//   new Chart(ctx2, {
//     type: 'line',
//     data: {
//       labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
//       datasets: [{
//         label: '# of Votes',
//         data: [0,10,20,30,38,40,38,45,50,50,45,39,34,29],
//         borderWidth: 3,
//         borderColor: '#EC0000', 
//         fill: true,
//         backgroundColor: '#ff000036',
//         lineTension: 0.5,
//       },
//       {
//         label: '# of ALTERNATIVES',
//         data: [0,7,17,27,35,37,35,42,47,47,42,36,31,26],
//         borderWidth: 3,
//         borderColor: '#8630FF', 
//         fill: true,
//         backgroundColor: '#d898d699',
//         lineTension: 0.5,
//       }]
//     },
//     options: {
//     //   scales: {
//     //     y: {
//     //       beginAtZero: true
//     //     }
//     //   }
//     }
// });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-form"] && !window.DesignMode) return;
  try {
    
$('.tab-menu li a').on('click', function(){

    var target = $(this).attr('data-rel');

    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});  

  } catch(e) { console.error(e); }
})();
})();
